import Vue from "vue"
import MoreAboutWidget from "./components/MoreAboutWidget.vue";
import Vuex from "vuex";
import {MoreAboutWidgetState} from "@/apps/MoreAboutWidget/models/more-about-widget-state";
import mutations from "@/apps/MoreAboutWidget/store/mutations";
import getters from "@/apps/MoreAboutWidget/store/getters";
import {root} from "@/shared/store";

Vue.config.productionTip = false;

let widgetSearchEls = document.querySelectorAll('widget-more-about');
if (widgetSearchEls.length) {
    widgetSearchEls.forEach(el => {
        let store = new Vuex.Store({
            state: new MoreAboutWidgetState,
            mutations: mutations,
            getters: getters,
            modules: {
                root
            }
        })

        new Vue({
            el: el,
            store,
            render(h) {
                let categories = this.$el.attributes.getNamedItem('categories');
                let labels = this.$el.attributes.getNamedItem('labels');
                return h(MoreAboutWidget, {
                    props: {
                        categories: categories ? JSON.parse(categories.value) : null,
                        labels: labels ? JSON.parse(labels.value) : null
                    }
                })
            }
        });
    });
}
